/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ContractVersion model module.
 * @module model/ContractVersion
 * @version 1.0.0
 */
class ContractVersion {
    /**
     * Constructs a new <code>ContractVersion</code>.
     * @alias module:model/ContractVersion
     */
    constructor() { 
        
        ContractVersion.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ContractVersion</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ContractVersion} obj Optional instance to populate.
     * @return {module:model/ContractVersion} The populated <code>ContractVersion</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ContractVersion();

            if (data.hasOwnProperty('document_name')) {
                obj['document_name'] = ApiClient.convertToType(data['document_name'], 'String');
            }
            if (data.hasOwnProperty('download_link')) {
                obj['download_link'] = ApiClient.convertToType(data['download_link'], 'String');
            }
            if (data.hasOwnProperty('published_at')) {
                obj['published_at'] = ApiClient.convertToType(data['published_at'], 'String');
            }
        }
        return obj;
    }


}

/**
 * The name of the contract PDF
 * @member {String} document_name
 */
ContractVersion.prototype['document_name'] = undefined;

/**
 * The download link for the contract PDF
 * @member {String} download_link
 */
ContractVersion.prototype['download_link'] = undefined;

/**
 * Contract publication date
 * @member {String} published_at
 */
ContractVersion.prototype['published_at'] = undefined;






export default ContractVersion;

